import React from 'react';

import AccessCodeTable from './AccessCodeTable';

export default () => <AccessCodeTable />;
